module.exports = __webpack_public_path__ + "assets/img/tongzhi.8b9f14a0.png";